import {Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from '../services/language.service';

@Pipe({name: 'localized', pure: false})
export class LocalizedPipe implements PipeTransform {
  constructor(private readonly language: LanguageService) {
  }

  transform(english?: string, german?: string): string {
    return this.language.localized(english, german);
  }
}
